<template>
  <div>
    <div
      :class="$vuetify.breakpoint.mobile ? 'flex-column mb-5' : 'justify-space-between'"
      class="d-flex"
    >
      <v-card-title
        class="titre-h3 mt-3 mb-3 ml-1"
      >
        Paramétrer des rebonds
      </v-card-title>
    </div>

    <BaseMessageServerError v-if="serverError" />
    <div>
      <BaseLoader v-if="loading" />
    </div>
    <v-row v-if="!loading">
      <v-col
        v-for="(redirection, index) in redirections"
        :key="index"
        cols="12"
        md="4"
        xl="3"
      >
        <v-card
          class="eq-height pr-2"
        >
          <CarteRebond
            :is-open-modal-ajout-redirection="isOpenModalAjoutRedirection"
            :redirection="redirection"
            @detail="onDetail"
            @edit="onEdit"
          />
        </v-card>
      </v-col>
      <v-col
        v-if="redirections.length"
        cols="12"
        md="4"
        xl="3"
      >
        <AjoutRebond
          :is-open-modal-ajout-redirection="isOpenModalAjoutRedirection"
          class="eq-height"
          @ajout-redirection="onAjouteRedirection"
        />
      </v-col>
      <v-col
        :md="redirections.length === 0 ? 12 : 3"
        cols="12"
      >
        <v-row no-gutters>
          <BaseCardV2
            v-if="!loading && redirections.length === 0"
            class="mt-5"
          >
            <div
              :class="$vuetify.breakpoint.mobile ? 'mt-6' :'mt-10' "
              class="d-flex align-center flex-column pb-6"
            >
              <div
                :class="$vuetify.breakpoint.mobile ? 'mb-6' :'mx-16' "
                class=" d-flex flex-column intro texte-gris-fonce text-align-center mt-2 text-justify mx-5"
              >
                <span class="mt-1 mb-5 text-center">Ajoutez votre premier rebond.</span>
                <AgrButton
                  :disabled="isOpenModalAjoutRedirection"
                  color="primary darken-1"
                  @click="onAjouteRedirection"
                >
                  <span class="action text-truncate white--text">Ajouter un rebond</span>
                </AgrButton>
              </div>
            </div>
          </BaseCardV2>
        </v-row>
      </v-col>
    </v-row>
    <v-dialog
      v-model="isOpenModalAjoutRedirection"
      fullscreen
      persistent
      transition="slide-x-transition"
    >
      <AjoutRebondModal
        v-if="isOpenModalAjoutRedirection"
        :redirection="redirectionSelected"
        :redirections="redirections"
        @close="onCloseAjoutRedirection()"
      />
    </v-dialog>
    <v-dialog
      v-model="isOpenModalDetailRedirection"
      fullscreen
      persistent
      transition="slide-x-transition"
    >
      <DetailRebondModal
        v-if="isOpenModalDetailRedirection"
        :redirection="redirectionSelected"
        @close="onCloseDetailRedirection()"
      />
    </v-dialog>
  </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
import BaseCardV2 from '@/components/card/base-card-v2.vue'
import BaseLoader from '@/components/common/base-loader.vue'
import BaseMessageServerError from '@/components/common/base-message-server-error.vue'
import AjoutRebond from '@/views/admin/rebond/components/ajout-rebond.vue'
import AjoutRebondModal from '@/views/admin/rebond/components/modal/ajout-rebond-modal.vue'
import DetailRebondModal from '@/views/admin/rebond/components/modal/detail-rebond-modal.vue'
import CarteRebond from '@/views/admin/rebond/components/carte-rebond.vue'
import {AgrButton} from '@agrial/ui'

export default {
  name: 'RebondAdmin',
  components: { AgrButton, AjoutRebond, AjoutRebondModal, BaseCardV2, BaseLoader, BaseMessageServerError, CarteRebond, DetailRebondModal },

  data () {
    return {
      loading: false,
      serverError: false,
      isOpenModalAjoutRedirection: false,
      isOpenModalDetailRedirection: false,
      redirectionSelected: null
    }
  },

  computed: {
    ...mapGetters({
      redirections: 'redirection/redirections',
    })
  },

  watch: {
    isOpenModalAjoutRedirection (newValue, oldValue) {
      //Si la modal d'ajout de redirection a perdu le focus ou a été fermé par le user
      if (!newValue && oldValue) {
        this.redirectionSelected = null
      }
    }
  },

  created () {
    this.loading = true
    this.getRedirections()
      .catch(() => {
        this.serverError = true
      })
      .finally(() => {
        this.loading = false
      })
  },

  methods: {
    ...mapActions({
      getRedirections: 'redirection/getRedirections',
    }),
    onAjouteRedirection () {
      this.isOpenModalAjoutRedirection = true
      this.redirectionSelected = null
    },
    onCloseAjoutRedirection () {
      this.isOpenModalAjoutRedirection = false
      this.redirectionSelected = null
    },
    onCloseDetailRedirection () {
      this.isOpenModalDetailRedirection = false
      this.redirectionSelected = null
    },
    onEdit (redirection) {
      this.redirectionSelected = redirection
      this.isOpenModalAjoutRedirection = true
    },
    onDetail (redirection) {
      this.redirectionSelected = redirection
      this.isOpenModalDetailRedirection = true
    }
  }
}
</script>
